import { render, staticRenderFns } from "./WayPoint.vue?vue&type=template&id=be9d069a&scoped=true"
import script from "./WayPoint.vue?vue&type=script&lang=js"
export * from "./WayPoint.vue?vue&type=script&lang=js"
import style0 from "./WayPoint.vue?vue&type=style&index=0&id=be9d069a&prod&lang=scss&scoped=true"
import style1 from "./WayPoint.vue?vue&type=style&index=1&id=be9d069a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9d069a",
  null
  
)

export default component.exports